import { render, staticRenderFns } from "./SlideFadeTransition.vue?vue&type=template&id=4a49d2d4&scoped=true"
import script from "./SlideFadeTransition.vue?vue&type=script&lang=js"
export * from "./SlideFadeTransition.vue?vue&type=script&lang=js"
import style0 from "./SlideFadeTransition.vue?vue&type=style&index=0&id=4a49d2d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49d2d4",
  null
  
)

export default component.exports